export default __webpack_public_path__ + "static/media/image_Quotas.4198feca.svg";